import React from 'react';

const RoutingRules = () => {
  return (
    <div className="routing-rules">
      <div className="flex flex-col justify-between">
        <h2>Routing Rules</h2>
        <a className="mt-4" target="_blank" href={`${window.CC_HOST}/settings?tab=routingRules`}>
          Open Command Center to review Routing Rules.
        </a>
      </div>
    </div>
  );
};
export default RoutingRules;
